/** Resolve column list_id to index in current descriptor-ordered columns arrays. */
export function getColumnById(columnId, columnDescriptors) {
  const list = Array.isArray(columnDescriptors) ? columnDescriptors : [];
  const index = list.findIndex((c) => String(c.id) === String(columnId));
  return index >= 0 ? { ...list[index], index } : null;
}
